import { Component, Input, OnChanges } from '@angular/core';
import { WorkOrderState } from 'app/_models/work-order-state';
import { WorkOrderStateService } from 'app/_services/work-order-state.service';

@Component({
  selector: 'work-order-state-badge',
  templateUrl: './work-order-state-badge.component.html',
})
export class WorkOrderStateBadgeComponent implements OnChanges {
  @Input() workOrder;
  private state: WorkOrderState;
  public stateDisplayValue: string;
  public badgeClass: string;

  constructor(
    private workOrderStateService: WorkOrderStateService,
  ) { }

  ngOnChanges() {
    this.state = this.workOrderStateService.setWorkOrderState(this.workOrder);
    this.badgeClass = this.workOrderStateService.workOrderStateToBadgeClass(this.state);


    if (this.state === WorkOrderState.Approved) {
      this.stateDisplayValue = 'Pending Release';
    } else if (this.state === WorkOrderState.Pending) {
      this.stateDisplayValue = 'Pending Approval';
    } else if (this.state === WorkOrderState.XferAcknowledged) {
      this.stateDisplayValue = WorkOrderState.PendingXfer;
    } else if (this.state === WorkOrderState.ReturnAcknowledged) {
      this.stateDisplayValue = WorkOrderState.PendingReturn;
    } else {
      this.stateDisplayValue = this.state;
    }
  }
}
